export default {"src":"/_next/static/media/renders.e9175eb6.svg","height":61,"width":68,"blurWidth":0,"blurHeight":0};